import React, { useState, useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import Modal from '../components/SpeedDial/Modal';
import { SpeedDial, SpeedDialData } from '@client/components/SpeedDial';
import SpeedDialEdit from '@client/components/SpeedDial/SpeedDialEdit';

type Theme = 'light' | 'dark' | 'system';

export const BookmarksPage: React.FC = () => {
    const [searchParams] = useSearchParams();
    const id = searchParams.get('id');

    const [isModalOpen, setIsModalOpen] = useState(false);
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [bookmarksOutline, setBookmarksOutline] = useState<string | undefined>(
        localStorage?.getItem('bookmarksOutline') ?? undefined,
    );
    const [bookmarksOutlineTs, setBookmarksOutlineTs] = useState<string | undefined>(
        localStorage?.getItem('bookmarksOutlineTs') ?? undefined,
    );
    const [bookmarksEmail, setBookmarksEmail] = useState<string | undefined>(
        localStorage?.getItem('bookmarksEmail') ?? undefined,
    );
    const [activeTab, setActiveTab] = useState<string>('');
    const [isEditMode, setIsEditMode] = useState(false);
    const defaultColumns = 5;
    // Theme State
    const [theme, setTheme] = useState<Theme>(() => {
        if (typeof localStorage !== 'undefined') {
            const saved = localStorage.getItem('theme');
            return (saved as Theme) || 'system';
        }
        return 'system';
    });
    useEffect(() => {
        document.title = 'Marcadores';
        const root = document.documentElement;
        const mediaQuery = window.matchMedia('(prefers-color-scheme: dark)');

        const applyTheme = () => {
            const isDark = theme === 'dark' || (theme === 'system' && mediaQuery.matches);

            if (isDark) {
                root.classList.add('dark');
            } else {
                root.classList.remove('dark');
            }
        };

        applyTheme();
        // Si no hay datos, mostrar el modal
        if (!bookmarksOutline || !bookmarksOutlineTs) {
            setIsModalOpen(true);
        }
        console.log(email, bookmarksOutlineTs);
        if (bookmarksEmail && bookmarksOutlineTs) {
            fetchCourseStructure(bookmarksEmail, undefined, bookmarksOutlineTs);
        }
    }, []);
    useEffect(() => {
        console.log('bookmarksOutline han cambiado', bookmarksOutline);

        bookmarksOutline
            ? localStorage.setItem('bookmarksOutline', bookmarksOutline)
            : localStorage.removeItem('bookmarksOutline');

        bookmarksOutlineTs
            ? localStorage.setItem('bookmarksOutlineTs', bookmarksOutlineTs)
            : localStorage.removeItem('bookmarksOutlineTs');

        bookmarksEmail
            ? localStorage.setItem('bookmarksEmail', bookmarksEmail)
            : localStorage.removeItem('bookmarksEmail');
    }, [bookmarksOutline]);

    const fetchCourseStructure = async (
        csemail: string,
        cspassword: string | undefined,
        csbookmarksOutlineTs?: string,
    ) => {
        try {
            const response = await fetch(
                `/api/bookmarks?email=${csemail}${cspassword ? '&password=' + cspassword : ''}${csbookmarksOutlineTs ? '&bookmarksTS=' + csbookmarksOutlineTs : ''}`,
            );
            if (response.ok) {
                const data = await response.json();
                console.log('Storing data in LS', data);

                if (data.bookmarks) {
                    const bookmarksOutline = JSON.stringify(data.bookmarks);
                    const bookmarksOutlineTs = data.bookmarksTS ?? undefined;

                    setBookmarksOutline(bookmarksOutline);
                    setBookmarksOutlineTs(bookmarksOutlineTs);
                    setBookmarksEmail(csemail);
                }
            }
        } catch (error) {
            console.error('Error fetching course structure:', error);
        }
    };
    const handleSubmit = () => {
        // Mostrar email y contraseña en consola
        console.log('Email:', email);
        console.log('Contraseña:', password);

        // Cerrar el modal después de enviar
        setIsModalOpen(false);

        fetchCourseStructure(email, password);
    };
    const onTabChange = (tab: string) => {
        console.log('tabChange', tab);
        setActiveTab(tab);
    };
    const handleGlobalSave = async (speedDialData: SpeedDialData) => {
        
        setIsEditMode(false);
        const rawResponse = await fetch('/api/bookmarks', {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                email: bookmarksEmail,
                bookmarksTS: bookmarksOutlineTs,
                bookmarks: speedDialData,
            }),
        });
        const content = await rawResponse.json();
        setBookmarksOutline(JSON.stringify(speedDialData));
        console.log(content);
    };
    // Si hay id, mostrar mensaje
    if (bookmarksOutline && bookmarksOutlineTs && bookmarksEmail) {
        return (
            <main className="flex-grow w-full max-w-[1600px] mx-auto">
                {isEditMode ? (
                    <SpeedDialEdit
                        data={JSON.parse(bookmarksOutline)}
                        defaultColumns={defaultColumns}
                        onTabChange={onTabChange}
                        onSave={handleGlobalSave}
                        defaultActiveTab={activeTab}
                        onEnableEdit={setIsEditMode}
                    />
                ) : (
                    <SpeedDial
                        data={JSON.parse(bookmarksOutline)}
                        defaultColumns={defaultColumns}
                        onTabChange={onTabChange}
                        defaultActiveTab={activeTab}
                        onEnableEdit={setIsEditMode}
                    />
                )}
            </main>
        );
    }

    // Si no hay id, mostrar el modal
    return (
        <>
            <Modal
                isOpen={isModalOpen}
                title="Iniciar Sesión"
                onClose={() => setIsModalOpen(false)}
                onSave={handleSubmit}
                saveLabel="Iniciar Sesión"
            >
                <div className="space-y-4">
                    <div>
                        <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">Email</label>
                        <input
                            type="email"
                            className="w-full px-3 py-2 bg-white dark:bg-slate-950 border border-gray-300 dark:border-slate-700 rounded-md focus:ring-2 focus:ring-blue-500 focus:outline-none dark:text-white"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            placeholder="tu@email.com"
                        />
                    </div>
                    <div>
                        <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
                            Contraseña
                        </label>
                        <input
                            type="password"
                            className="w-full px-3 py-2 bg-white dark:bg-slate-950 border border-gray-300 dark:border-slate-700 rounded-md focus:ring-2 focus:ring-blue-500 focus:outline-none dark:text-white"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            placeholder="••••••••"
                        />
                    </div>
                </div>
            </Modal>
        </>
    );
};
